import { Controller } from "@hotwired/stimulus"

// Per-card image carousel for the Advent Calendars 2026 sales page.
// Replaces the mockup's vanilla JS (old Babel: no ?. and no ??).
export default class extends Controller {
  static targets = ["slide", "dot"]

  connect() {
    this.index = 0
  }

  prev(event) {
    event.preventDefault()
    this.show(this.index - 1)
  }

  next(event) {
    event.preventDefault()
    this.show(this.index + 1)
  }

  show(position) {
    const count = this.slideTargets.length
    if (count === 0) {
      return
    }

    this.index = ((position % count) + count) % count
    this.slideTargets.forEach((slide, i) => slide.classList.toggle("on", i === this.index))
    this.dotTargets.forEach((dot, i) => dot.classList.toggle("on", i === this.index))
  }
}
